import { Moment } from '@intelipost-js/secure-providers';

export default {
  getChartData(state, getter) {
    if (!state.shipmentsByInterval) return null;

    return state.shipmentsByInterval.map((interval) => {
      const shipments = interval.shipments_array
                                .map(shipment => shipment.amount);

      return [
        getter.getPeriod(interval.week_start, interval.week_end),
        ...shipments,
      ];
    });
  },

  getPeriod: () => (start, end) =>
    `${Moment(start).format('DD/MM')} até ${Moment(end).format('DD/MM')}`,
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-shipment-interval/store/getters.js